/* eslint-disable no-continue */
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import cloneDeep from 'lodash/cloneDeep';
import { isEmpty } from 'lodash';
import { getUTCTimestamp } from '../../utils';

const HELPER = {
  LABEL_QUESTION_DISPLAY_TYPES: ['list', 'questions_group', 'breadcrumb', 'label'],
  getRandomId: () => {
    return Math.random().toString(36).substring(7);
  },
  extractAnswer: (answer, currentAnswer = []) => {
    if (typeof answer !== 'object') {
      return answer;
    }
    if (isPlainObject(answer) && answer.type === 'array') {
      let _currentAnswer = currentAnswer;
      if (_currentAnswer && !Array.isArray(_currentAnswer)) {
        _currentAnswer = [_currentAnswer];
      }
      //   _currentAnswer = _currentAnswer && Array.isArray(_currentAnswer) ? _currentAnswer?.map((a) => a?.id || a) : _currentAnswer;
      if (answer.checked) {
        return [..._currentAnswer, answer.id];
      }
      return _currentAnswer.filter((a) => a !== answer.id);
    }
    if (typeof answer === 'object') {
      return answer;
    }
    return null;
  },
  /**
   *
   */
  updateResetAnswer: (obj, currentAnswer) => {
    const { reset, answer } = obj;
    const isReset = reset.filter((item) => item.id === answer.id)[0];
    let _currentAnswer = currentAnswer;
    if (_currentAnswer && !Array.isArray(_currentAnswer)) {
      _currentAnswer = [_currentAnswer];
    }
    if (answer.checked) {
      if (isReset) {
        return [answer.id];
      }
      if (_currentAnswer.length) {
        return [
          ..._currentAnswer.filter((a) => {
            return reset.filter((item) => item.id !== a).length;
          }),
          answer.id,
        ];
      }
      return [answer.id];
    }
    return _currentAnswer.filter((a) => a !== answer.id);
  },

  addOrReplace: (list = [], obj, key) => {
    let matchFound = false;
    let newList = [];
    newList = list.map((item) => {
      if (item.question_id === obj.question_id) {
        matchFound = true;
        // !!! transaction log must not modify existing answer object
        // except for transaction_log related keys
        if (key === 'transaction_log' && !isEmpty(obj.transactionLog)) {
          const timeStampData = obj.transactionLog;
          const numTimesAnswered = timeStampData.length;
          return {
            ...item,
            transaction_log: timeStampData,
            num_times_answered: numTimesAnswered,
            last_submitted_at: obj.lastSubmittedAt,
          };
        }
        let resp = {
          ...item,
          question_id: obj.question_id,
          hasEdit: obj.hasEdit || false,
          hasMask: obj.hasMask || false,
          [key]: obj.reset
            ? HELPER.updateResetAnswer(obj, item.answer)
            : HELPER.extractAnswer(obj[key], item.answer),
          ...(obj.hasMask && key === 'answer' && { [key]: obj.actualResponse || obj[key] }),
        };
        if (obj.parentId) {
          resp = {
            ...resp,
            parentId: obj.parentId,
          };
        }
        if (obj.immediateParent) {
          resp = {
            ...resp,
            immediateParent: obj.immediateParent,
          };
        }
        // Parent List Question Id - N List
        if (obj.parentListQuestionId) {
          resp = {
            ...resp,
            parentListQuestionId: obj.parentListQuestionId,
          };
        }
        // Parent List Question Id - Normal List
        if (obj.listParentId) {
          resp = {
            ...resp,
            listParentId: obj.listParentId,
          };
        }
        // Normal List Index
        if (Number.isInteger(obj.listIndex) && obj.listIndex >= 0) {
          resp = {
            ...resp,
            listIndex: obj.listIndex,
          };
        }
        return resp;
      }
      return item;
    });
    if (!matchFound) {
      const isArrayType = get(obj, 'answer.type', '') === 'array';
      if (obj.question_id && isArrayType) {
        const _answer = get(obj, 'answer.id', '');
        newList.push({ ...obj, answer: [_answer] });
      } else {
        newList.push(obj);
      }
    }
    return newList;
  },

  /**
   *
   */
  getRequiredSchema: (list) => {
    return list.reduce((acc, question) => {
      if (HELPER.LABEL_QUESTION_DISPLAY_TYPES.indexOf(question.display_type) > -1) {
        return acc;
      }
      if (
        get(question, 'validations.required.value', false) &&
        !get(question, 'is_hidden', false)
      ) {
        acc.push(question.question_id);
      }
      return acc;
    }, []);
  },

  /**
   *
   */
  isDisplayTypeQuestion: (question) => {
    return question.question_type !== 'group';
  },

  /**
   *
   */
  parseArray: (list, rex = 0) => {
    const parentList = list;
    for (let index = 0; index < parentList.length; index += 1) {
      const question = parentList[index];
      if (question.display_type !== 'image_text') {
        if (question.submission_type === 'all') continue;
        if (
          HELPER.isDisplayTypeQuestion(question) &&
          question.questions &&
          question.questions.length
        ) {
          if (question.child_questions) {
            const rIndex = question.reflexive_index === undefined ? 0 : question.reflexive_index;
            parentList.splice(
              index + 1,
              0,
              ...question.questions.map((q) => ({
                ...q,
                reflexive_index: rIndex + 1,
                question_id: q.question_id.toString(),
              })),
            );
          } else if (question.question_type === 'modal') {
            parentList.splice(
              index + 1,
              0,
              ...question.questions.map((q) => ({
                ...q,
                isModalQuestion: true,
                question_id: q.question_id.toString(),
              })),
            );
          } else {
            parentList.splice(
              index + 1,
              0,
              ...question.questions.map((q) => ({ ...q, question_id: q.question_id.toString() })),
            );
          }
          question.questions.length = 0;
        }
        if (question.questions && question.questions.length) {
          HELPER.parseArray(question.questions, question.reflexive_index);
        } else if (question.original_questions && question.original_questions.length) {
          HELPER.parseArray(question.original_questions, question.reflexive_index);
        }
        question.reflexive_index = question.reflexive_index || rex;
      }
    }
  },

  /**
   * @description function to extract and insert reflexive questions in the question list.
   * @param {Object} questionObject - the parent (group) question after the breadcrumb.
   */
  insertReflexiveQuestion: (questionObject, hasModal = false) => {
    const questionList = [cloneDeep(questionObject)];
    HELPER.parseArray(questionList);
    const temp = [];
    HELPER.flattenQuestions(questionList, temp, 0, hasModal);
    return temp;
  },
  findAndGetTimeStamp: (questionList, questionId) => {
    const question = questionList.find((q) => q.question_id === questionId);
    return {
      question_id: question?.question_id ?? '',
      num_times_answered: question?.num_times_answered ?? 0,
      transaction_log: question?.transaction_log ?? [],
      last_submitted_at: question?.last_submitted_at ?? '',
    };
  },
  /**
   * @description funtion to flatten the questions.
   * @param questions question list - array
   * @param newList array
   * @param shouldFlatListQ boolean
   */
  flattenQuestions: (questions, newList, shouldFlatListQ = false, hasModal = false) => {
    if (Array.isArray(questions) && questions.length) {
      questions.forEach((question) => {
        newList.push({
          ...question,
        });
        if (
          question.questions &&
          question.submission_type !== 'all' &&
          (shouldFlatListQ || question.display_type !== 'list') &&
          get(question, 'properties.appearance.value', '') !== 'accordion' &&
          question.display_type !== 'image_text'
        ) {
          let nestedQs = question.questions;
          if (
            shouldFlatListQ &&
            Array.isArray(question.original_questions) &&
            question.original_questions.length
          ) {
            nestedQs = question.original_questions;
          }
          const nextSet = cloneDeep(nestedQs);
          if (hasModal) {
            // eslint-disable-next-line no-param-reassign
            question.questions.length = 0;
          }
          HELPER.flattenQuestions(nextSet, newList, shouldFlatListQ, hasModal);
        }
      });
    }
  },
  /**
   * @description functione extracts the current breadcrumb name and transforms it
   * to a keyword.
   * @param {Object} data received from the backend
   * @returns {String}
   */
  getCurrentBreadcrumb: (breadcrumbs, id) => {
    const breadcrumb = breadcrumbs.filter((item) => {
      if (id && item.state === 'active') {
        return item.title.replace(/ /g, '').toLowerCase() === id;
      }
      return item.state === 'active';
    })[0];
    if (breadcrumb) {
      return {
        id:
          breadcrumb.breadcrumb_id.toLowerCase() ||
          breadcrumb.title.replace(/ /g, '').toLowerCase(),
        index: breadcrumbs.findIndex((obj) => obj.breadcrumb_id === breadcrumb.breadcrumb_id),
        active: true,
        ...breadcrumb,
      };
    }
    return null;
  },

  /**
   *
   */
  shouldEnableContinue: (
    requiredSchema = [],
    allAnswers,
    allErrors = [],
    isList = false,
    listDisplay = false,
    listError = false,
    eSign,
  ) => {
    let enable = true;
    if (allErrors.length !== 0) {
      return false;
    }

    if (listError) {
      return false;
    }

    for (let index = 0; index < requiredSchema.length; index += 1) {
      const answeredQuestion = allAnswers.filter(
        (item) => item.question_id === requiredSchema[index] && (item.answer || item.answer === 0),
      );
      if (!answeredQuestion.length) {
        enable = false;
        break;
      }

      const { answer } = answeredQuestion[0];
      if (isArray(answer) && !answer.length) {
        enable = false;
        break;
      }
    }

    if (isList && !listDisplay) {
      enable = false;
    }

    if (eSign) {
      const { hasESign, eSignEnable } = eSign;
      if (hasESign) {
        enable = enable && eSignEnable;
      }
    }

    return enable;
  },

  getTimeStamps: (previousTime, timeObj) => {
    if (Object.keys(timeObj).length) {
      const time = previousTime ? [...previousTime, timeObj] : [timeObj];
      return time;
    }
    return [];
  },

  findAndUpdateTimeStamp: (questionList, questionId, transactionLog, lastSubmittedAt) => {
    return questionList.map((question) => {
      if (question.question_id === questionId) {
        const numTimesAnswered = get(question, 'num_times_answered', undefined);
        return {
          ...question,
          transaction_log: transactionLog,
          num_times_answered: numTimesAnswered ? numTimesAnswered + 1 : 1,
          last_submitted_at: lastSubmittedAt,
        };
      }
      return question;
    });
  },

  getOperatingSystem: (window) => {
    let operatingSystem = 'Not known';
    if (window.navigator.appVersion.indexOf('Win') !== -1) {
      operatingSystem = 'Windows OS';
    }
    if (window.navigator.appVersion.indexOf('Mac') !== -1) {
      operatingSystem = 'MacOS';
    }
    if (window.navigator.appVersion.indexOf('X11') !== -1) {
      operatingSystem = 'UNIX OS';
    }
    if (window.navigator.appVersion.indexOf('Linux') !== -1) {
      operatingSystem = 'Linux OS';
    }

    return operatingSystem;
  },

  getBrowser: (userAgent) => {
    let browserName = '';
    if (userAgent.match(/edg/i)) {
      browserName = 'Edge';
    } else if (userAgent.match(/opr\//i)) {
      browserName = 'Opera';
    } else if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = 'Google Chrome';
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = 'Mozilla Firefox';
    } else if (userAgent.match(/safari/i)) {
      browserName = 'Safari';
    } else if (userAgent.match(/trident/i)) {
      browserName = 'MS IE';
    } else {
      browserName = 'Other';
    }
    return browserName;
  },

  getDeviceType: () => {
    const ua = navigator.userAgent;
    let deviceType = '';
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      deviceType = 'Tablet';
      if (/ipad/i.test(ua)) deviceType = 'Tablet - iPad';

      return deviceType;
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua,
      )
    ) {
      deviceType = 'Mobile';
      if (/iP(hone|od)/i.test(ua)) deviceType = 'Mobile - iPhone';
      return deviceType;
    }
    deviceType = 'Desktop';
    return deviceType;
  },

  /**
   * Check if present device is iphone/ipad/ipod
   * @returns {Boolean}
   */
  isIOS: () => {
    const isIphoneIpod = /iPhone|iPod/.test(navigator.userAgent);

    const isIpad = /iPad/.test(navigator.userAgent);

    const isMacUA = /Macintosh/.test(navigator.userAgent);
    const isTouchScreen = navigator?.maxTouchPoints >= 1;

    const versionSplit = navigator?.userAgent?.split('Version/')[1] || '';
    const ipadVersion = versionSplit.split('.')[0];

    const isTouchScreenIpad = isMacUA && isTouchScreen && ipadVersion > 12;

    return isIphoneIpod || isIpad || isTouchScreenIpad;
  },

  /**
   * Fetch major iOS version
   */
  getIOSMajorVersion: () => {
    if (HELPER.isIOS()) {
      const iosVersion = HELPER.getMobileOSVersion();
      return +iosVersion?.split('.')[0];
    }
    return null;
  },

  /**
   * Returns iOS/Android version eg: 16.3, 12.0.5
   * @returns {String}
   */
  getMobileOSVersion: () => {
    const ua = navigator?.userAgent;
    if (HELPER.isIOS()) {
      if (HELPER.getBrowser(ua) === 'Safari') {
        const versionSplit = ua.split('Version/')[1] || '';
        return versionSplit?.split(' ')[0] || '';
      }
      const versSplit = ua.split(' OS ')[1];
      return versSplit?.split(' ')[0]?.replaceAll('_', '.') || '';
    }
    if (ua.includes(' Android ')) {
      const versionSplit = ua.split(' Android ')[1] || '';
      return versionSplit?.split(';')[0] || '';
    }
    return '';
  },

  isValidAnswer: (answer) => {
    if (typeof answer === 'string' || typeof answer === 'number') {
      return !!answer;
    }
    if (isArray(answer) && answer.length) {
      return true;
    }
    if (isPlainObject(answer) && answer.id) {
      return true;
    }
    return false;
  },

  /**
   * @description This function inserts new and updates existing audit timestamp values
   * when auditRequired value is true for the particular questionId.
   */
  insertAndUpdateTimestamp: (audit = [], questionId, auditRequired = false) => {
    if (auditRequired) {
      const currentUTCTimestamp = getUTCTimestamp();
      const hasAudit = audit.filter((a) => a.question_id === questionId);
      if (hasAudit.length) {
        return audit.map((a) => {
          if (a.question_id === questionId) {
            return {
              ...a,
              timestamp: currentUTCTimestamp,
            };
          }
          return a;
        });
      }
      return [
        ...audit,
        {
          question_id: questionId,
          timestamp: currentUTCTimestamp,
        },
      ];
    }
    return [];
  },

  findAndUpdateResponse: (
    questionList,
    questionId,
    response,
    questionResponse,
    isControlledInput = false,
  ) => {
    return questionList.map((question) => {
      if (question.question_id === questionId) {
        return {
          ...question,
          isControlledInput,
          response: HELPER.isValidAnswer(questionResponse)
            ? questionResponse
            : HELPER.extractAnswer(response, question.response),
        };
      }
      return question;
    });
  },
  // sort 2 JSON arrays by prop value
  getSortOrder(prop) {
    return (a, b) => {
      if (a[prop] > b[prop]) {
        return 1;
      }
      if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    };
  },

  // returns the answers array of matching id
  getAnswersArray(answersArray, questionId) {
    return answersArray.filter((question) => question.question_id === questionId);
  },

  removeDuplicate: (sectionAllQuestions, currentQuestions) => {
    // check for two layout property for question
    const layout = get(currentQuestions, 'properties.layout', undefined);
    let currentQuestionId;
    if (!currentQuestions.questions) {
      currentQuestionId = currentQuestions.questionId;
    } else {
      currentQuestionId = layout
        ? currentQuestions.questions[1].question_id
        : currentQuestions.questions[0].question_id; // get the questions_groups question id
    }
    return sectionAllQuestions.reduce((acc, questions) => {
      // check index 2 for first question in the list and for index 1 fro two-column question
      if (
        questions.questionList[1].question_id === currentQuestionId ||
        (layout && questions.questionList[0].question_id === currentQuestionId)
      ) {
        return acc;
      }
      acc.push({
        ...questions,
        completed: true,
      });
      return acc;
    }, []);
  },

  replaceSectionQuestion: (oldQuestions, newQuestionsList, index) => {
    return oldQuestions.map((quesObj, i) => {
      if (i === index) {
        const requiredSchema = HELPER.getRequiredSchema(newQuestionsList);
        return {
          ...quesObj,
          questionList: newQuestionsList,
          requiredSchema,
          enableContinue: HELPER.shouldEnableContinue(requiredSchema, quesObj.answersArray),
        };
      }
      return quesObj;
    });
  },

  buildAnswersArrayReduceFunc: (Q, arr) => {
    return Q.reduce((acc, q) => {
      if (
        q.display_type === 'list' ||
        q.display_type === 'questions_group' ||
        q.display_type === 'breadcrumb'
      ) {
        return acc;
      }
      if (q.question_id) {
        let { response } = q;
        if (isPlainObject(response)) {
          response = response.id ? response.id : response?.name;
        }
        if (isArray(response)) {
          response = response.map((r) => r.id);
        }
        // Checks if question contain masked value.
        const mask = !!get(q, 'validations.mask.mask_char', false);
        acc.push({
          question_id: q.question_id,
          answer: response,
          hasEdit: false,
          hasMask: mask,
        });
      }
      return acc;
    }, arr);
  },

  buildAnswersArray: (questionList, originalQ = []) => {
    const answersArray = [];
    HELPER.buildAnswersArrayReduceFunc(questionList, answersArray);
    HELPER.buildAnswersArrayReduceFunc(originalQ, answersArray);
    return answersArray;
  },

  getOriginalQuestions: (questionObject) => {
    const listQuestion = questionObject.questions[0];
    if (listQuestion.display_type === 'list') {
      // Adds reflexive questions support for list questions
      // Related Task - https://sureify.atlassian.net/browse/AS-323
      const reflexiveListQ = [];
      HELPER.flattenQuestions(
        listQuestion.original_questions || listQuestion.questions,
        reflexiveListQ,
        true,
      );
      return reflexiveListQ;
    }
    return [];
  },

  getAnsweredLisQuestionIds: (questionObj) => {
    const listQuestions = questionObj.filter(
      (question) => question.display_type === 'list' && question.child_questions_completed_flag,
    );
    return listQuestions.filter((q) => q.questions?.length).map((q) => q.question_id);
  },
};

export const { getCurrentBreadcrumb } = HELPER;

export default HELPER;
